import { render, staticRenderFns } from "./VideoImage.vue?vue&type=template&id=d85cd5ea&scoped=true"
import script from "./VideoImage.vue?vue&type=script&lang=js"
export * from "./VideoImage.vue?vue&type=script&lang=js"
import style0 from "./VideoImage.vue?vue&type=style&index=0&id=d85cd5ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85cd5ea",
  null
  
)

export default component.exports